import { AbstractControl, ValidatorFn } from '@angular/forms';

export function IsNumberValidator(): ValidatorFn {
    return (control: AbstractControl): Record<string, unknown> | null => {
        const reg = new RegExp('^[0-9]+$');
        const isNumber = reg.test(control?.value);
        if (!isNumber) {
            if (control.value === '') {
                return null;
            }

            return {
                numberError: { value: 'value is not a number' },
                req: { value: true },
            };
        }
        return null;
    };
}
